import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { Storage } from '@ionic/storage';

import { BusinessProductManagerHandler } from '../../providers/business-product-handler';

import { BusinessProductListPage } from '../business-product-list/business-product-list';

import { Camera, CameraOptions } from '@ionic-native/camera';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-product-manager',
  templateUrl: 'business-product-manager.html',
})
export class BusinessProductManagerPage {
	@ViewChild('fileInput') fileInput;

	product: any;
	productImage: any = [];
	categories: any = [];
	hasMedia: boolean;
	private form : FormGroup;
	public imageSrc: string;
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	saveIsLoading: boolean = false;
	deleteIsLoading: boolean = false;
	imageChanging: boolean = false;

  	constructor(  		
  		private toastCtrl: ToastController,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public productManagerHandler: BusinessProductManagerHandler,
		public storage: Storage,
		private camera: Camera,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController,
		public _DomSanitizer: DomSanitizer
		) {

  		this.product = navParams.data['product'];
  		this.categories = navParams.data['categories'];
		
	    this.form = this.formBuilder.group({
	    	"Id": [''],
		  	"ProductName":  ['', Validators.required],
		  	"SubCategoryId": ['', Validators.required],
		    "Price": ['', Validators.required],
		    "IsActive": [false],
	   	});   
  	}

  	ionViewWillEnter() {
		if(this.product.Id){
	   		this.loadProduct(this.product.Id);
	    } else {
	    	this.productImage = []
	    }
	}

	loadProduct(id){
		this.isLoading = true;

		this.productManagerHandler.getProduct(id, (result)=>{
		  	
		  	if(result.Id != ''){
		  		this.product = result;

		  		this.form.patchValue(
					this.product
		    	)

		    	var productImage = {ImagePath: result.ImagePath}

		    	this.productImage.push(productImage);

		    	this.hasMedia = this.productImage.length > 0;		    	
		  	}

		  	this.isLoading = false;
		})
	}

	deleteProduct(){
		this.deleteIsLoading = true;
		
		this.productManagerHandler.deleteProduct(this.product.Id, (result)=>{
			this.deleteIsLoading = true;

			if(result.Success)
				this.navCtrl.pop();
			else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});			
	}

	presentDeleteConfirmation() {
	  let alert = this.alertCtrl.create({
	    title: 'Confirm deletion',
	    message: 'Do you want to delete this product?',
	    buttons: [
	      {
	        text: 'Delete',
	        handler: () => {
	          console.log('Delete clicked');
	          this.deleteProduct()
	        }
	      },
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          console.log('Cancel clicked');
	        }
	      }
	    ]
	  });
	  alert.present();
	}

	onSubmit(){
		if(this.saveIsLoading)
			return
		
		this.saveIsLoading = true;

		if(this.form.value.Id != ''){

			console.log("entered update");

			this.productManagerHandler.updateProduct(this.form.value.Id, this.form.value, (result)=>{
				if(result.Success){
					let toast = this.toastCtrl.create({
						message: 'Product has been updated',
						duration: 3000,
						position: 'bottom'
					});

					toast.present();						
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}

				this.saveIsLoading = false;
			})

		} else {
			console.log("entered create");

			this.productManagerHandler.createProduct(this.form.value, (result)=>{
				if(result.Success){
					this.loadProduct(result.Data.Id);
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}
			  				  	
				this.saveIsLoading = false;
			})
		}		  	
	}

	getPicture() {
	    if (Camera['installed']()) {

	      this.presentActionSheet();
	    
	    } else {
	      
	      this.fileInput.nativeElement.click();
	    
	    }
	}

	presentActionSheet() {
	   let actionSheet = this.actionSheetCtrl.create({
	     title: 'Choose the source for an image',
	     buttons: [
	       {
	         text: 'Camera',
	         handler: () => {
	           console.log('Archive clicked');

	           this.getImage(true)
	         }
	       },
	       {
	         text: 'Image Gallery',
	         handler: () => {
	           console.log('Archive clicked');

	           this.getImage(false)
	         }
	       },
	       {
	         text: 'Cancel',
	         role: 'cancel',
	         handler: () => {
	           console.log('Cancel clicked');
	         }
	       }
	     ]
	   });

	   actionSheet.present();
	}

	private getImage (fromCamera): void {
		var sourceType = fromCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY

		const options: CameraOptions = {
	  	  	sourceType: sourceType,
		  	destinationType: this.camera.DestinationType.DATA_URL,  
		    mediaType: this.camera.MediaType.PICTURE,    
		    allowEdit: true,
		    quality: 30,
		    targetWidth: 500,
		    targetHeight: 500,
		    encodingType: this.camera.EncodingType.PNG,      
		    correctOrientation: true
		}

		this.imageChanging = true;

		this.camera.getPicture(options).then((dataUrl) => {
			console.log(dataUrl);
			
			this.productManagerHandler
			.uploadProductImage({
				id: this.product.Id,
				imageString: 'data:image/png;base64,' + dataUrl,
				cb: (data)=>{ 
					this.imageChanging = false;

					var productImage = {ImagePath: data.Data}

					this.product.ImagePath = data.Data;

					this.form.patchValue(
						productImage
			    	)
				}
			})

		}, (err) => {
		 // Handle error
		 alert('Unable to take photo');
		 this.imageChanging = false;
		});
	}

	processWebImage(event) {
		var file = event.target.files[0];
		var extension = file.name.substr((file.name.lastIndexOf('.') + 1));

		if(extension == 'png') {
		    let reader = new FileReader();

		    reader.onload = (readerEvent) => {

			    let imageData = (readerEvent.target as any).result;

			    this.imageChanging = true;

				this.productManagerHandler
				.uploadProductImage({
					id: this.product.Id,
					imageString: imageData,
					cb: (data)=>{ 
						this.imageChanging = false;

						var productImage = {ImagePath: data.Data}

						this.product.ImagePath = data.Data;

						this.form.patchValue(
							productImage
				    	)
					}
				})
		    }; 

		    reader.readAsDataURL(event.target.files[0]);
		} else {

			let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: "Only images with a png extension are allowed.",
				    	buttons: ['Ok']
				  	});
				  	
		  	alert.present();

		}
	}

	confirmRemoveMedia(productId) {
	    const confirm = this.alertCtrl.create({
	      title: 'Alert',
	      message: 'Do you want to remove this image?',
	      buttons: [
	        {
	          text: 'No',
	          handler: () => {
	          }
	        },
	        {
	          text: 'Yes',
	          handler: () => {
	            console.log('Agree clicked');

	            this.removeMedia(productId)
	          }
	        }
	      ]
	    });
	    confirm.present();
	}

	removeMedia(mediaId){
		var loader = this.loadingCtrl.create({
			content: "Deleting...",
			showBackdrop: true
		});

		loader.present(); 

		this.deleteIsLoading = true;
		
		this.productManagerHandler.deleteProductImage(mediaId, (result)=>{
			this.deleteIsLoading = false;
			loader.dismiss();  

			if(result.Success) {
				console.log(this.productImage)
				this.productImage = this.productImage.filter(function(item) {
					console.log("Filter")
					console.log(mediaId)

				    return item.Id != mediaId;
				});
				console.log("After delete")
				console.log(this.productImage)

				// this.hasMedia = this.productImage.length > 0;

				this.product.ImagePath = null;

				var productImage = {ImagePath: null}

				this.form.patchValue(
					productImage
		    	)		    	

				let alert = this.alertCtrl.create({
	              title: 'Sucess',
	              subTitle: "Image has been removed",
	              buttons: ['Ok']
	            });

	            alert.present();
			} else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/pages/business-product-manager/business-product-manager.ts